import { Column, DataTable } from "@/components/organisms/DataTable";
import { useGetAllAssignMaterials } from "@/config/modules/assignMaterials/services/useGetAllAssignMaterials";
import type { GreenCenterMaterials } from "@/service/namek/useGetMaterialsByCVId";

import { MaterialsCell } from "./MaterialsCell";
import { AssignMaterialActions } from "./AssignMaterialActions";

export function AssignMaterialList() {
  const { data, isFetching } = useGetAllAssignMaterials();

  return (
    <DataTable
      dataKey="id"
      loading={isFetching}
      paginator={false}
      scrollHeight="flex"
      value={data ?? []}
    >
      <Column sortable field="name" header="Centro verde" />
      <Column sortable field="cooperative.name" header="Cooperativa" />
      <Column
        body={(row: GreenCenterMaterials) => (
          <MaterialsCell materials={row.materials} tooltipId={`materials-${row.id}`} />
        )}
        field="materials"
        header="Materiales"
      />
      <Column
        frozen
        alignFrozen="right"
        body={(row: GreenCenterMaterials) => <AssignMaterialActions assignMaterials={row} />}
        style={{ width: "50px" }}
      />
    </DataTable>
  );
}
